import * as Lucide from "lucide-react";

// Renders a lucide icon by its string name (from backend data), with a safe fallback.
export function Icon({ name, className, size = 20, strokeWidth = 1.5, style }) {
  const Cmp = Lucide[name] || Lucide.Circle;
  return <Cmp className={className} size={size} strokeWidth={strokeWidth} style={style} />;
}
